import React from 'react';

import { contentBuilderPropTypes } from '../../utils/propTypes';

import ContentDisplay from './ContentDisplay';
import ContentEditor from './ContentEditor';

const propTypes = contentBuilderPropTypes.content;

const SlideContent = (props) => {

	const {
		data,
		resourceContent,
		isEditing,
		filestack,
		triggers,
		onCancel,
		onSave,
	} = props;

	const id = data.id;
	const type = data.type;
	const width = data.width;
	const showTitle = data.show_title;
	const scope = data.scope;
	const scopeId = data.scope_id;

	const initialValues = {
		title: resourceContent?.title,
		content: resourceContent?.content,
		width,
		language: data.language,
		resourceContents: data.resource_contents,
		deletedResourceContents: data.deleted_resource_contents,
	};

	const headingLevel = data.path.split('#').length - 1;

	return (
		<div>
			{isEditing &&
				<ContentEditor
					id={id}
					type={type}
					initialValues={initialValues}
					isNew={!data.created_at}
					filestack={filestack}
					onCancel={onCancel}
					onSave={onSave}
					onLanguageChange={triggers?.onLanguageChange}
					onWidthChange={triggers?.onWidthChange} />
			}
			{!isEditing &&
				<ContentDisplay
					key={`${id}-${data.updated_at}`}
					id={id}
					content={resourceContent?.content}
					headingLevel={headingLevel}
					title={resourceContent?.title}
					showTitle={showTitle}
					scope={scope}
					scopeId={scopeId}
					filestack={filestack}
					onLinkClick={triggers?.onLinkClick} />
			}
		</div>
	);

};

SlideContent.propTypes = propTypes;

export default SlideContent;
